/**
 * Ancienne page « résultat d'une épreuve » (`/p/:parcoursId/evaluation/:id`).
 *
 * Les résultats d'une épreuve se lisent désormais dans la fiche du candidat,
 * sur l'onglet de l'épreuve. Les liens déjà envoyés ou mis en favori restent
 * valides : on les redirige vers cet onglet, `?from=` conservé.
 */
import { cleEpreuve } from "@repo/campagne";
import { useQuery } from "convex/react";
import { Loader2 } from "lucide-react";
import { Navigate, useParams, useSearchParams } from "react-router";
import { api } from "@convex/_generated/api";
import type { Id } from "@convex/_generated/dataModel";

export function RedirectionResultatEpreuve() {
  const { parcoursId, evaluationId } = useParams<{
    parcoursId: string;
    evaluationId: string;
  }>();
  const [searchParams] = useSearchParams();
  const detail = useQuery(
    api.parcoursEvaluations.obtenirDetailParcoursAdmin,
    parcoursId
      ? { parcoursId: parcoursId as Id<"parcoursEvaluations"> }
      : "skip",
  );

  if (detail === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  const cible = new URLSearchParams();
  const from = searchParams.get("from");
  if (from) cible.set("from", from);
  const epreuve = detail?.evaluations.find((e) => e.evalId === evaluationId);
  // Épreuve inconnue de ce parcours : la vue d'ensemble, qui dira ce qu'il y a.
  if (epreuve) cible.set("fiche", cleEpreuve(epreuve));
  const suite = cible.toString();

  return <Navigate to={`/p/${parcoursId}${suite ? `?${suite}` : ""}`} replace />;
}
